import {
  checkAndReload as checkAndReloadApi,
  init as initApi,
  resizeUpload as resizeUploadApi,
  update as updateApi
} from "../../service/UpdateStickerService";

export const INIT_SUCCESS = "UPDATE_STICKER_INIT_SUCCESS";
export const INIT_FAIL = "UPDATE_STICKER_INIT_FAIL";
export const CHANGE_FILE_SELECTED = "UPDATE_STICKER_CHANGE_FILE_SELECTED";
export const RESIZE_UPLOAD_SUCCESS = "UPDATE_STICKER_RESIZE_UPLOAD_SUCCESS";
export const RESIZE_UPLOAD_FAIL = "UPDATE_STICKER_RESIZE_UPLOAD_FAIL";
export const UPDATE_SUCCESS = "UPDATE_STICKER_UPDATE_SUCCESS";
export const UPDATE_FAIL = "UPDATE_STICKER_UPDATE_FAIL";
export const CHECK_AND_RELOAD_SUCCESS = "UPDATE_STICKER_CHECK_AND_RELOAD_SUCCESS";
export const CHECK_AND_RELOAD_FAIL = "UPDATE_STICKER_CHECK_AND_RELOAD_FAIL";

export const init = params => dispatch => {
  initApi(params).then(() => {
    dispatch({
      type: INIT_SUCCESS,
      payload: {
        listId: params.listId,
        itemId: params.itemId,
        stickerId: params.stickerId,
        beforeStickerFile: params.stickerFileName
      }
    });
  });
};
export const fileSelect = files => dispatch => {
  const selectedFile = files[0];
  console.log(selectedFile);
  if (!selectedFile) return;
  const temporaryURL = URL.createObjectURL(selectedFile);
  dispatch({
    type: CHANGE_FILE_SELECTED,
    payload: {
      selectedImageURL: temporaryURL
    }
  });
};

export const resizeUpload = file => (dispatch, getState) => {
  // ファイル名重複チェック
  const beforeFileName = getState().updateSticker.beforeStickerFile;
  if (beforeFileName && file.name === beforeFileName) {
    dispatch({ 
      type: RESIZE_UPLOAD_FAIL, 
      payload: { 
        messageCode: "01_08_004",
        message: "変更前と同じファイルです。別のファイルを選択してください。", 
        error: "CHANGE_BEFORE_AND_SAME_FILE_01_08_004" 
      } 
    });
    alert(`メッセージコード: 01_08_004\r\nメッセージ：変更前と同じファイルです。別のファイルを選択してください。`);
    return;
  }

  const reader = new FileReader();
  reader.onload = function() {
    const img = new Image();
    img.onload = function() {
      // 縮小後のサイズを指定
      const targetWidth = 195;
      const targetHeight = 250;

      // 画像を縮小する
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = targetWidth;
      canvas.height = targetHeight;

      ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
      console.log("縮小された画像データ:", canvas.toDataURL("image/jpeg"));

      resizeUploadApi({
        imageData: canvas.toDataURL("image/jpeg"),
        fileName: file.name,
        listId: getState().updateSticker.listId
      })
        .then(response => {
          console.log(response);
          dispatch({ type: RESIZE_UPLOAD_SUCCESS });
          dispatch(checkAndReload(file.name));
        })
        .catch(error => {
          dispatch({ type: RESIZE_UPLOAD_FAIL, payload: { message: "リサイズ画像のアップロードに失敗。", error: error } });
          console.log(error);
        });
    };
    img.src = reader.result;
  };
  reader.readAsDataURL(file);
};

export const directUpload = file => (dispatch, getState) => {
  // ファイル名重複チェック
  const beforeFileName = getState().updateSticker.beforeStickerFile;
  if (beforeFileName && file.name === beforeFileName) {
    dispatch({ 
      type: RESIZE_UPLOAD_FAIL, 
      payload: { 
        messageCode: "01_08_004",
        message: "変更前と同じファイルです。別のファイルを選択してください。", 
        error: "CHANGE_BEFORE_AND_SAME_FILE_01_08_004" 
      } 
    });
    alert(`メッセージコード: 01_08_004\r\nメッセージ：変更前と同じファイルです。別のファイルを選択してください。`);
    return;
  }

  const reader = new FileReader();
  reader.onload = function() {
    resizeUploadApi({
      imageData: reader.result,
      fileName: file.name,
      listId: getState().updateSticker.listId
    })
      .then(response => {
        console.log(response);
        dispatch({ type: RESIZE_UPLOAD_SUCCESS });
        dispatch(checkAndReload(file.name));
      })
      .catch(error => {
        dispatch({ 
          type: RESIZE_UPLOAD_FAIL, 
          payload: { 
            message: "ファイルのアップロードに失敗。", 
            error: error 
          } 
        });
        console.log(error);
      });
  };
  reader.readAsDataURL(file);
};

export const checkAndReload = fileName => (dispatch, getState) => {
  checkAndReloadApi({
    listId: getState().updateSticker.listId,
    fileName: fileName
  }).then(response => {
    if (response.message !== null) {
      dispatch({
        type: CHECK_AND_RELOAD_FAIL,
        payload: {
          messageCode: response.messageCode,
          message: response.message
        }
      });
      alert(`メッセージコード: ${response.messageCode}\r\nメッセージ：${response.message}`);
    } else {
      dispatch({ type: CHECK_AND_RELOAD_SUCCESS });
      dispatch(update(fileName));
    }
  });
};

export const update = fileName => (dispatch, getState) => {
  updateApi({
    listId: getState().updateSticker.listId,
    itemId: getState().updateSticker.itemId,
    stickerId: getState().updateSticker.stickerId,
    beforeFileName: getState().updateSticker.beforeStickerFile,
    afterFileName: fileName
  }).then(response => {
    if (response.message !== null) {
      dispatch({
        type: UPDATE_FAIL,
        payload: {
          messageCode: response.messageCode,
          message: response.message
        }
      });
      alert(`メッセージコード: ${response.messageCode}\r\nメッセージ：${response.message}`);
    } else {
      dispatch({ type: UPDATE_SUCCESS });
      alert("ステカファイルを更新しました。");
      window.location.href = "/UpdateValuationItemMaster";
    }
  });
};
